import { styled } from "@mui/material/styles";
import { Switch } from "@mui/material";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#1890ff", // 다크 모드 처리
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)", // 다크 모드 처리
    boxSizing: "border-box",
  },
}));

export const CommonSwitch = (props) => {
  const { checked = false, onChange, ...rest } = props;
  const safeChecked = !!checked;
  return (
    <AntSwitch
      inputProps={{ "aria-label": "ant design" }}
      checked={safeChecked}
      onChange={(event) => onChange?.(event.currentTarget.checked)}
      {...rest} // 나머지 props 전달 (disabled 포함)
    />
  );
};
